import React from "react";
import Women from "../components/Women";

const WomenPage = () => {
  return (
    <>
      <Women />
    </>
  );
};

export default WomenPage;
